import React  from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";

import withMobileDialog from "@material-ui/core/withMobileDialog";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import {
    Grid
} from "@material-ui/core"
import { appHelpers } from "../../_helpers";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    input: {
        marginTop: "0 !important"
    },
    nb: {
        color: "red",
        fontSize: "12px"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: "67%"
    },
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    paragraph: {
        color: '#999999',
        fontFamily: 'Poppins',
        textAlign: 'left',
        margin: 0,
        fontSize: '0.9em'
    },
    heading: {
        color: '#3C4858',
        fontFamily: 'Poppins',
        textAlign: 'left',
        margin: 0
    },
    headerContainer:{
        display: 'flex',
        padding: '10px 0',
        justifyContent: 'space-around'
    }
});

function viewMoreTableData (props){
    const  {
        isViewMoreOpen, closeViewMore, classes, moreData, filterStatus, filterUsers
    } =props;
    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={isViewMoreOpen}
                onClose={closeViewMore}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: "#66bb6a" }}>
                    <span style={{ color: "white", textTransform: "uppercase" }}> {moreData.Airline}</span>
                </DialogTitle>
                <DialogContent style={{ marginTop: "20px" }}>
                    <Grid container spacing={24}>
                        <Card>
                            <CardHeader color="success" stats icon>
                                <div className={classes.headerContainer}>
                                    <Grid container spacing={24}>
                                        <Grid item xs={3}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Airline
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {moreData.Airline}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Flight Number
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {moreData.FlightNo}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Departure Date
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {(moreData.DepartureDate) ? appHelpers.formatDate(moreData.DepartureDate, "MMM DD, YYYY") : ""}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Departure Location
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {moreData.DepartureLocation}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Destination Location
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {moreData.DestinationLocation}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Passenger Count
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {moreData.PassengerCount}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Billable Passenger Count
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {moreData.BillablePassengerCount}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Created By
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {filterUsers(moreData.CreatedBy)}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Created Date
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {(moreData.DateSubmitted) ? appHelpers.formatDate(moreData.DateSubmitted, "MMM DD, YYYY") : ""}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Processed By
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {filterUsers(moreData.ProcessedBy)}
                                                </h4>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className={classes.paragraph}>
                                                <p className={classes.paragraph}>
                                                    Status
                                                </p>
                                                <h4 className={classes.heading}>
                                                    {filterStatus(moreData.Status)}                                        </h4>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </CardHeader>
                        </Card>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeViewMore} color="danger">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default (withMobileDialog()(withStyles(styles)(viewMoreTableData)));



// WEBPACK FOOTER //
// ./src/views/PDM/ViewMore.jsx